/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue";
import SinglePicker from '@/components/Base/SinglePicker';
export default {
  name: 'SelectPicker',
  props: {
    list: Array
  },
  components: {
    SinglePicker: SinglePicker,
    Cell: Cell
  },
  data: function data() {
    return {
      isShowPicker: false
    };
  },
  created: function created() {}
};